module.exports = __webpack_public_path__ + "img/progress_092.714272a2.png";